import { BlockConfig, zeroIOPS, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const appServerConfig: BlockConfig = {
  displayName: "App Server",
  imagePath: "",
  isInitiator: true,
  isTerminator: true,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.USER,
    BlockTypes.LOAD_BALANCER,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.LAMBDA,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.QUEUE,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set([
    BlockTypes.DATABASE,
    BlockTypes.DB_READ_REPLICA,
    BlockTypes.LAMBDA,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.QUEUE,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.GRAPH_DB,
    BlockTypes.DOCUMENT_DB,
    BlockTypes.S3_BUCKET,
    BlockTypes.PASSTHROUGH,
  ]),
  inputCapacity: {
    total: 1500,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 900,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 300,
          [`${ContentTypes.STATIC}`]: 300,
          [`${ContentTypes.STATIC_MEDIA}`]: 300,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 600,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 400,
          [`${ContentTypes.STATIC_MEDIA}`]: 200,
        },
      },
    },
  },
  processingCapacity: zeroIOPS(),
  purchasePrice: 100,
  sellPrice: 50,
  costPerCycle: 0.6,
  outputConnectorLimits: {},
};
